export const FORM_MODES = {
  CNPJ: 'cnpj',
  CPF: 'cpf',
};
